import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import Autodesk from 'assets/images/auth/autodesk.webp';
import GoogleDrive from 'assets/images/auth/googledrive_result.webp';
import Redas from 'assets/images/auth/redas_result.webp';
import Synology from 'assets/images/auth/synology_logo_result.webp';
import SGBuildex from 'assets/images/auth/sgbuildex_result.webp';

import { connectAutodesk, connectGoogleDrive, connectRedas, connectSgbuildex, deleteConnection, fetchConnections } from '../services/connectionService';

export const PROVIDER_IMAGE_MAP = {
  googledrive: GoogleDrive,
  autodesk: Autodesk,
  synology: Synology,
  redas: Redas,
  sgbuildex: SGBuildex
};

export const WIDTH_IMAGE_PROVIDER = {
  googledrive: 60,
  autodesk: 60,
  synology: 100,
  redas: 60,
  sgbuildex: 50
};

export const LABEL_PROVIDER = {
  googledrive: 'Google',
  autodesk: 'ACC',
  synology: 'Synology',
  redas: 'Redas',
  sgbuildex: 'SGBuildex'
};

export const useConnections = () => {
  return useQuery({
    queryKey: ['connections'],
    queryFn: fetchConnections,
    select: (data) =>
      data.map((item) => ({
        ...item,
        label: LABEL_PROVIDER[item.provider] ?? null,
        max: WIDTH_IMAGE_PROVIDER[item.provider] ?? null,
        img: PROVIDER_IMAGE_MAP[item.provider] ?? null
      }))
  });
};

export const useDeleteConnection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteConnection,

    // refresh connection list
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['connections'] });
    }
  });
};


export const useConnectAutodesk = () =>{
  return useQuery({
      queryKey: ["autodesk-login"],
      queryFn: () => connectAutodesk(),
  });
}

export const useConnectGoogleDrive = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: connectGoogleDrive,

    onSuccess: () => {
      // 🔥 refresh connection list
      queryClient.invalidateQueries({ queryKey: ['connections'] });
    }
  });
};

export const useConnectRedasConnection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: connectRedas,

    onSuccess: () => {
      // 🔥 refresh connection list
      queryClient.invalidateQueries({ queryKey: ['connections'] });
    }
  });
};

export const useConnectSgbuildex = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: connectSgbuildex,

    onSuccess: () => {
      // 🔥 refresh connection list
      queryClient.invalidateQueries({ queryKey: ['connections'] });
    }
  });
};
